import CloseIcon from "@assets/images/close-thin.svg";
import { Box, Drawer, Grid } from "@material-ui/core";
import { Color } from "@material-ui/lab/Alert";
import MyTypography from "@saleor/components/MyTypography";
import Skeleton from "@saleor/components/Skeleton";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import { STAFF_UPDATE } from "@saleor/config";
import { DomesticOrderSortField } from "@saleor/createOrderDomestic/urls";
import {
  AddProductsToDomesticOrderMutation,
  ContractQuery,
  useAddProductsToDomesticOrderMutation
} from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { SortPage } from "@saleor/types";
// import { PROD_CATEG_1 } from "@saleor/utils/constants";
import { formatDate } from "@saleor/utils/date";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import ModalProductDetail from "../../../createOrder/components/ModalProductDetail/ModalProductDetail";
import TableProducts from "./TableProducts";

type OrderLines = AddProductsToDomesticOrderMutation["addProductsToDomesticOrder"]["orderLines"];

interface DrawAddProductProps extends SortPage<DomesticOrderSortField> {
  contract?: ContractQuery["contract"];
  onClose: () => void;
  open: boolean;
  contractId: string;
  orderId: string;
  cartId?: string;
  refetchData?: () => void;
  handleAddMoreData?: (data: OrderLines) => void;
  staffUpdate?: number;
  isReFetechData?: boolean;
  remainProductInOrderLinesCateg1?: any;
  remainChangeOrderCateg1?: any;
  remainProductInOrderLines?: any;
  remainChangeOrder?: any;
  soNo?: string;
  setVisibleDialogError?: (e: boolean) => void;
  setPopUpContent?: (e: any) => void;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      height: 720,
      background: theme.palette.background.default,
      padding: "4.8rem 4rem 2rem 4rem",
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)",
      borderTopLeftRadius: 32,
      borderTopRightRadius: 32,
      color: theme.palette.grey[900]
    },
    headerClose: {
      position: "absolute",
      top: 30,
      right: 46,
      zIndex: 2,
      "& button": {
        background: "none",
        border: "none",
        padding: 0,
        display: "inline-flex",
        marginLeft: 18,
        "& img": {
          width: 12,
          height: 12
        }
      }
    },

    mainTitle: {
      color: theme.palette.info.dark
    },
    subTitle: {
      color: theme.palette.info.dark
    },
    orderInfoSection: {
      marginBottom: 18
    },
    orderDetail: {
      "& > div": {
        display: "inline-block",
        marginRight: 32
      }
    },
    tableTitle: {
      margin: "21px 0 16px"
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    inlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    }
  }),
  { name: "DrawAddProductDomestic" }
);

const DrawAddProductDomestic: React.FC<DrawAddProductProps> = ({
  contract,
  onClose,
  contractId,
  orderId,
  cartId,
  staffUpdate,
  refetchData,
  open,
  isReFetechData,
  sort,
  remainProductInOrderLinesCateg1 = {},
  remainChangeOrderCateg1 = {},
  remainProductInOrderLines = {},
  remainChangeOrder = {},
  onSort,
  handleAddMoreData,
  soNo,
  setVisibleDialogError,
  setPopUpContent
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [openModalProduct, setOpenModalProduct] = useState<boolean>(false);
  const [productIdModal, setProductIdModal] = useState<string>("");
  const [contractMaterialIdModal, setContractMaterialIdModal] = useState<
    string
  >("");

  const [_remainInOrderLines, setRemainInOrderLines] = useState<number>(0);
  const [remainInChangeOrder, setRemainInChangeOrder] = useState<number>(0);
  const [typeAlert, setTypeAlert] = useState<Color>("success");
  const [openAlert, setOpenAlert] = useState<boolean>(false);

  const [addProductToDomesticOrder] = useAddProductsToDomesticOrderMutation();
  const [isChangeOrderLineUpdatedMat, setChangeOrderLineUpdatedMat] = useState<
    boolean
  >(false);

  const isCreateOrderFlow =
    window.location.href.includes("create-order") ||
    window.location.href.includes("sold-to");

  const isChangeOrderFlow = !isCreateOrderFlow ? true : false;

  const handleOpenModal = (productId, contractMaterialId) => {
    setProductIdModal(productId);
    setContractMaterialIdModal(contractMaterialId);
    setOpenModalProduct(true);
    setRemainInOrderLines(remainProductInOrderLines[contractMaterialId] || 0);
    setRemainInChangeOrder(remainInChangeOrder[contractMaterialId] || 0);
    // console.log("Mat84 Change Order");
    // console.log("remainProductInOrderLines", remainProductInOrderLines[contractMaterialId]);
    // console.log("remainInChangeOrder", remainInChangeOrder[contractMaterialId]);
  };

  const prodErrorContent = (
    <>
      {" "}
      <MyTypography variant="body2" className={classes.inlineBlock}>
        กรุณาเลือก{" "}
        <MyTypography variant="subtitle2" className={classes.inlineBlock}>
          สินค้ากลุ่มเดียวกัน
        </MyTypography>{" "}
        {isChangeOrderFlow ? "ในการแก้ไขคำสั่งซื้อ" : "ในการสร้างคำสั่งซื้อ"}
      </MyTypography>
    </>
  );
  const handleSuccessAdd = () => {
    if (isReFetechData && refetchData) {
      refetchData();
    }
  };

  const handleAddToOrder = product => {
    addProductToDomesticOrder({
      variables: {
        id: orderId,
        input: [
          {
            contractMaterialId: product.id,
            quantity: product.quantity,
            materialVariantId: undefined
          }
        ]
      }
    }).then(({ data }) => {
      if (
        data?.addProductsToDomesticOrder?.errors[0]?.code ===
        "PRODUCT_GROUP_ERROR"
      ) {
        setVisibleDialogError(true);
        setPopUpContent(prodErrorContent);
        return;
      }
      if (data?.addProductsToDomesticOrder?.errors?.length) {
        setTypeAlert("error");
        setOpenAlert(true);
        return;
      }
      setTypeAlert("success");
      setOpenAlert(true);
      setChangeOrderLineUpdatedMat(true);
      if (handleAddMoreData) {
        handleAddMoreData(
          data?.addProductsToDomesticOrder?.orderLines.map(line => ({
            ...line,
            refDocIt: product.itemNo
          }))
        );
      }
      handleSuccessAdd();
    });
  };

  const handleAddMoreDataMultipleVariant = list => {
    handleAddMoreData(
      list.map(line => ({
        ...line,
        refDocIt: contract?.products.find(
          product => product.id === contractMaterialIdModal
        )?.itemNo
      }))
    );
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  useEffect(() => {
    // console.log("Is New Item Added", isChangeOrderLineUpdatedMat);
  }, [isChangeOrderLineUpdatedMat]);

  return (
    <>
      <SnackbarAlert
        severity={typeAlert}
        open={openAlert}
        onClose={handleCloseAlert}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <div className={classes.snackHeadTitle}>
          <MyTypography
            variant="subtitle2"
            style={{ color: "#ffffff", marginRight: "2px" }}
          >
            {staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
            staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC
              ? intl.formatMessage({
                  defaultMessage: "Added to order",
                  description: "dialog header"
                })
              : intl.formatMessage({
                  defaultMessage: "Added to cart",
                  description: "dialog header"
                })}
          </MyTypography>
          <MyTypography variant="body3" style={{ color: "#ffffff" }}>
            {typeAlert === "success"
              ? staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
                staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC
                ? "เพิ่มสินค้าในคำสั่งซื้อสำเร็จ"
                : "เพิ่มสินค้าลงตะกร้าสำเร็จ"
              : ""}
            {typeAlert === "error"
              ? staffUpdate === STAFF_UPDATE.UPDATE_ORDER ||
                staffUpdate === STAFF_UPDATE.ADD_ORDER_DOMESTIC
                ? "เพิ่มสินค้าในคำสั่งซื้อไม่สำเร็จ"
                : "เพิ่มสินค้าลงตะกร้าไม่สำเร็จ"
              : ""}
          </MyTypography>
        </div>
      </SnackbarAlert>
      <Drawer
        data-testid="drawerAddProductDomestic"
        open={open}
        anchor={"bottom"}
        PaperProps={{
          className: classes.root
        }}
      >
        <MyTypography variant={"caption"} className={classes.headerClose}>
          {intl.formatMessage({ defaultMessage: "ปิดหน้าต่าง" })}
          <button
            id="closeButton"
            data-testid="closeButton"
            onClick={() => onClose()}
          >
            <img src={CloseIcon} alt="close-button" />
          </button>
        </MyTypography>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            md={3}
            data-testid="drawerAddProductDomestic-title"
          >
            <MyTypography variant="h5" className={classes.mainTitle}>
              {intl.formatMessage({ defaultMessage: "เพิ่มรายการสินค้า" })}
            </MyTypography>
            <MyTypography variant="body2" className={classes.subTitle}>
              {intl.formatMessage({ defaultMessage: "สำหรับคำสั่งซื้อ" })}
            </MyTypography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className={classes.orderInfoSection}>
              <MyTypography variant="captionBold">
                {intl.formatMessage({ defaultMessage: "Contract No." })}
              </MyTypography>
              <MyTypography variant="subtitle1">
                {contract?.contractNo}
              </MyTypography>
            </Box>
            <Box>
              <MyTypography variant="captionBold">
                {intl.formatMessage({ defaultMessage: "Sold-to Party" })}
              </MyTypography>
              <MyTypography variant="body3">
                {contract ? contract?.customer?.displayText : <Skeleton />}
              </MyTypography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={classes.orderInfoSection}>
              <MyTypography variant="captionBold">
                {intl.formatMessage({ defaultMessage: "ชื่อโครงการ" })}
              </MyTypography>
              <MyTypography variant="body3" style={{ color: "#333333" }}>
                {contract ? contract.projectName : <Skeleton />}
              </MyTypography>
            </Box>
            <Box className={classes.orderDetail}>
              <Box>
                <MyTypography variant="captionBold">
                  {intl.formatMessage({ defaultMessage: "BU" })}
                </MyTypography>
                <MyTypography variant="body3">
                  {contract ? (
                    contract?.company?.businessUnit?.name
                  ) : (
                    <Skeleton />
                  )}
                </MyTypography>
              </Box>
              <Box>
                <MyTypography variant="captionBold">
                  {intl.formatMessage({ defaultMessage: "Company" })}
                </MyTypography>
                <MyTypography variant="body3">
                  {contract ? contract?.company?.name : <Skeleton />}
                </MyTypography>
              </Box>
              <Box>
                <MyTypography variant="captionBold">
                  {intl.formatMessage({ defaultMessage: "วันที่เริ่มต้น" })}
                </MyTypography>
                <MyTypography variant="body3">
                  {contract ? formatDate(contract.startDate) : <Skeleton />}
                </MyTypography>
              </Box>
              <Box>
                <MyTypography variant="captionBold">
                  {intl.formatMessage({ defaultMessage: "วันที่สิ้นสุด" })}
                </MyTypography>
                <MyTypography variant="body3">
                  {contract ? formatDate(contract.endDate) : <Skeleton />}
                </MyTypography>
              </Box>
              <Box>
                <MyTypography variant="captionBold">
                  {intl.formatMessage({
                    defaultMessage: "เงื่อนไขการชำระเงิน"
                  })}
                </MyTypography>
                <MyTypography variant="body3">
                  {contract ? contract.paymentTermDescTh : <Skeleton />}
                </MyTypography>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <MyTypography variant="body1" className={classes.tableTitle}>
          {intl.formatMessage({
            defaultMessage: `รายการสินค้า `
          })}
          ({contract?.products?.length || 0})
        </MyTypography>
        <TableProducts
          remainProductInOrderLinesCateg1={remainProductInOrderLinesCateg1}
          remainProductInOrderLines={remainProductInOrderLines}
          remainChangeOrderCateg1={remainChangeOrderCateg1}
          remainChangeOrder={remainChangeOrder}
          isCreateOrderFlow={isCreateOrderFlow}
          isChangeOrderLineUpdatedMat={isChangeOrderLineUpdatedMat}
          products={contract?.products || []}
          contract={contract}
          onClickButton={handleOpenModal}
          onAddToCart={handleAddToOrder}
          sort={sort}
          onSort={onSort}
          staffUpdate={staffUpdate}
        />
      </Drawer>
      <ModalProductDetail
        isChangeOrderFlow={isChangeOrderFlow}
        isCreateOrderFlow={isCreateOrderFlow}
        soNo={soNo}
        remainInCart={remainProductInOrderLines[contractMaterialIdModal] || 0}
        remainInChangeOrder={remainInChangeOrder}
        contractMaterialId={contractMaterialIdModal}
        contractId={contractId}
        orderId={orderId}
        productId={productIdModal}
        open={openModalProduct}
        onClose={() => setOpenModalProduct(false)}
        userId={contract?.customer?.id}
        staffUpdate={staffUpdate}
        cartId={cartId}
        onAddProductComplete={handleSuccessAdd}
        handleAddMoreData={handleAddMoreDataMultipleVariant}
        setPopUpContent={setPopUpContent}
        prodErrorContent={prodErrorContent}
        setVisibleDialogError={setVisibleDialogError}
      />
    </>
  );
};

export default DrawAddProductDomestic;
